// src/components/admin/TorreDeControl/modals/RecipientModal.jsx
import React, { useState, useEffect } from 'react';
import { X, User } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function RecipientModal({ item, onClose, onUpdate }) {
  const [formData, setFormData] = useState({
    recipient_name: '',
    recipient_phone: '',
    recipient_dni: '',
    user_id: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (item) {
      setFormData({
        recipient_name: item.recipient_name || '',
        recipient_phone: item.recipient_phone || '',
        recipient_dni: item.recipient_dni || '',
        user_id: item.user_id || '',
      });
    }
  }, [item]);

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.put(`${API_URL}/api/admin/delivery-point/${item.id}/recipient`, formData);
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating recipient:', error);
      alert('Error al actualizar destinatario');
    } finally {
      setIsLoading(false);
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="bg-[#B1336E] px-6 py-4 flex items-center justify-between">
          <h3 className="text-white font-bold text-lg flex items-center gap-2 font-montserrat">
            <User className="w-5 h-5" />
            Actualizar Destinatario
          </h3>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Nombre del Destinatario
            </label>
            <input
              type="text"
              name="recipient_name"
              value={formData.recipient_name}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Teléfono
            </label>
            <input
              type="tel"
              name="recipient_phone"
              value={formData.recipient_phone}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              DNI
            </label>
            <input
              type="text"
              name="recipient_dni"
              value={formData.recipient_dni}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              ID Usuario
            </label>
            <input
              type="number"
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div className="flex gap-3 pt-4 border-t border-slate-200">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 bg-[#B1336E] hover:bg-[#B1336E]/90 disabled:bg-slate-300 text-white px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              {isLoading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RecipientModal;